import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import { selectLeadsListItems } from "../../../../../../../../redux/leads/selector";
import MobileViewTable from "../../../../../../../../common/components/mobile-view-table.component";
import PageLoader from "../../../../../../../../components/PageLoader";
import { leads } from "../../../../../../../../redux/leads/action";

const CustomerLeadsMobile = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [index, setIndex] = useState(1)
  const [hasMore, setHasMore] = useState();
  const [rawData, setRawData] = useState<any>([])
  const [leadData, setLeadData] = useState<any>([])
  const itemsData = useSelector(selectLeadsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.LeadInfo.Name', headerName: 'Name', sortable: true, filter: true, search: true },
      { field: 'Message.LeadInfo.Email', headerName: 'Email' },
      { field: 'Message.LeadInfo.PhoneNumber', headerName: 'Phone', sortable: true, filter: true },
      { field: 'Message.CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
      { field: 'Message.ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
    ]);
  }

  const fetchLeads = async (_page: any, size: any) => {
    dispatch(leads.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/list`, entity: 'leads', jsonData: {
        "PageNumber": _page,
        "PageSize": size,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  const handleSearch = async (data: any) => {

    const searchCriteria = [{
      FieldName: "Name",
      FieldText: "Name",
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
    await setLeadData([])
    await dispatch(leads.resetAction({ actionType: 'list' }))
    await dispatch(leads.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/list`, entity: 'leads', jsonData: {
        "PageNumber": index,
        "PageSize": 30,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleDelete = async (data: any) => {
    await dispatch(leads.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/delete`,
      entity: 'leads',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: data?.Message?.Id
            }

          }
        ]
      }
    }))
    await setLeadData([])
    await fetchLeads(index, 10)
  }
  useEffect(() => {
    if (index > 1) {
      createColumnDefs()
      fetchLeads(index, 10)
    }
  }, [index])

  useEffect(() => {
    createColumnDefs()
    fetchLeads(index, 10)
  }, [])

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  const fetchMoreData = () => {
    const prevIndex = index
    setIndex(prevIndex + 1);
  };

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload Leads</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlereload(),
    }
  ];
  const handlereload = async () => {
    await setLeadData([])
    await fetchLeads(index, 10)
  }
  useEffect(() => {
    if (itemsData?.result?.items) {
      setRawData(itemsData?.result?.items)
      setHasMore(itemsData?.result?.pagination?.HasNextPage)
    }
  }, [itemsData]);

  useEffect(() => {
    let formatedData = []
    rawData.map((data: any) => {
      formatedData.push({
        Context: data?.Context,
        Message: {
          Id: data?.Message?.Id,
          LeadInfo: {
            Name: data?.Message?.LeadInfo?.Name,
            Email: data?.Message?.LeadInfo?.Email,
            PhoneNumber: data?.Message?.LeadInfo?.PhoneNumber
          },

          CreatedOnUtc: data?.Message?.CreatedOnUtc,
          ModifiedOnUtc: data?.Message?.ModifiedOnUtc,
        }
      })
    })
    if (index > 1) {
      setLeadData([...leadData, ...formatedData])
    } else {
      setLeadData(formatedData)
    }

  }, [rawData])

  return (
    <>
      {itemsData?.isLoading && index == 1 ? <PageLoader />
        :

        <MobileViewTable
          dataLength={leadData.length}
          onSearch={handleSearch}
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          additionButtons={additionButtons}
          columnData={columnDefs}
          rowData={leadData}
          onEdit={handleEdit}
          onDelete={handleDelete}
          headingName="Leads" />

      }
    </>



  );
};

export default CustomerLeadsMobile;


